<div class="page-contents" style="background: #E5E5E5">
  <div class="levelOne-full-container" id='levelOne' style="min-width:960px;max-width:960px;border-right: 0">
    <child-header [title]="title" (closeEvent)="navigateTo('/home')"></child-header>
    <div [innerHTML]="cms?.innerHtml | sanitizeHtml" class="p-2" style="overflow-y: auto"></div>
  </div>
</div>
